import script from "./OrderMonthlyColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderMonthlyColumn.vue?vue&type=script&setup=true&lang=ts"

import "./OrderMonthlyColumn.vue?vue&type=style&index=0&id=6fe17f70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe17f70"]])

export default __exports__